export default __webpack_public_path__ + "static/digitaloutreach-a5ecead5d204bd3621c4054ab8aaeb2a.png";